class ValidateProductService {
    constructor(restangular) {
        this._api = restangular;
    }

    validate(stockcodes) {
        return this._api.one(`Product/Eligibility/${stockcodes.join()}`).get();
    }
}

ValidateProductService.$inject = ['Restangular'];

module.exports = { ValidateProductService };



// WEBPACK FOOTER //
// ./src/shop/validateproduct/validateproduct.service.js